require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./ignite-askmeanything-registration.json") })
        }
      }, "path---ignite-askmeanything-registration");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---ignite-askmeanything-registration!./.cache/json/ignite-askmeanything-registration.json
// module id = 1071
// module chunks = 231608221292675